module.exports = __webpack_public_path__ + "static/flask-brain-19fc6b6905a7c74d6cbeae5ecfad63da.svg";